module.exports = __webpack_public_path__ + "static/logos-tiles-vi-9c351d3e37fb4a03e359e432a98bd358.svg";